import { validateEnum, validateArray } from "../core/Helpers";
export var GooglePayCardNetworkObj = {
    AMEX: "AMEX",
    DISCOVER: "DISCOVER",
    ELECTRON: "ELECTRON",
    ELO: "ELO",
    ELO_DEBIT: "ELO_DEBIT",
    INTERAC: "INTERAC",
    JCB: "JCB",
    MAESTRO: "MAESTRO",
    MASTERCARD: "MASTERCARD",
    VISA: "VISA",
};
export var validateGooglePayCardNetwork = function (googlePayCardNetwork) {
    return validateEnum(googlePayCardNetwork, GooglePayCardNetworkObj);
};
export var validateGooglePayCardNetworkArray = function (googlePayCardNetworkArray) {
    return validateArray(googlePayCardNetworkArray, validateGooglePayCardNetwork);
};
